"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getHost = _interopRequireDefault(require("./get-host.js"));
var _sites = _interopRequireDefault(require("./sites.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Get the site config based on the given options.
*/
var _default = ({
  req,
  defaultSiteKey = 'slate'
} = {}) => {
  const FEATURE_GOODFOOD_RETHEME = parseInt(process.env.FEATURE_GOODFOOD_RETHEME, 10) === 1;
  const host = (0, _getHost.default)(req);
  const defaultConfig = _sites.default[defaultSiteKey];
  const result = Object.entries(_sites.default).find(([, {
    domain
  }]) => {
    const pattern = new RegExp(domain);
    return pattern.test(host);
  });
  if (!result && !defaultConfig) {
    throw new Error('No site config could be established for the current host and ' + `the \`defaultSiteKey\` of "${defaultSiteKey}" does not map to a known site.`);
  }
  if (!result) {
    return {
      siteKey: defaultSiteKey,
      ...defaultConfig
    };
  }
  const [siteKey, siteConfigValue] = result;
  const siteConfig = {
    siteKey,
    ...siteConfigValue
  };
  if (FEATURE_GOODFOOD_RETHEME && siteKey === 'bbcgoodfood') {
    siteConfig.theme = 'im-bbcgoodfood-retheme-theme';
  }
  return siteConfig;
};
exports.default = _default;